export const whiteListedExperienceIds = [
  '5ed154efcdaa59775870bdba', // Gold Rush Cincinnati
  '5fa9b6713aeaad2c3c6a347c', // Gold Rush Grapevine
  '5f75dc969c3a69598b2e42de', // Gold Rush Irvine
  '5ef4abf3c1c914735f4edc90', // Gold Rush King of Prussia
  '5eebc73f16eca638dd7f77a5', // The Heist Chicago
  '5ed15770466d086ba51982bd', // The Heist Cincinnati
  '5ecd7342e845573fa41fbdc2', // The Heist Grapevine
  '5f75dcf0cd56914cf51108ff', // The Heist Irvine
  '5ee8fbe2dced7a260e4713ca', // The Heist Jacksonville
  '5ef4ac352cb43b1c87426a8b', // The Heist King of Prussia
  '5ec2c4a3a175bc6e3f2ac848', // The Heist Nashville: Berry Hill
  '5eebc9e6211261065d70a655', // The Heist New Orleans
  '5f778e4c9ec4a51c3a7687c0', // Prison Break Chicago
  '5f1b3b26a5b1a41f794077b4', // Prison Break Cincinnati
  '5fa9b6fe25bc13706e4a63a6', // Prison Break Grapevine
  '5fb3f4bbf901b972276a2338', // Prison Break Irvine
  '5f75dbb550e5d2760d0a1b66', // Prison Break Jacksonville
  '5f1b3c495cd5a14ae55a59fd', // Prison Break King of Prussia
  '5f108a4dc9b6cb673f427a08', // Prison Break Nashville: Berry Hill
  '5fb59eb477f7c25d83393abe', // Prison Break New Orleans
  '61a7f8b2a3d9215bee53f320', // The Depths Irvine
  '612e7b39ebbf5d44fd30f5f5', // The Depths Nashville: Berry Hill
]
